import { getAuth } from "firebase/auth";
import { logDebug, logError } from "../LocalLogger";

export class NetworkIdentity {
	private static _backendToken: string | null = null;
	public static get backendToken() {
		if (this._backendToken) {
			return this._backendToken;
		}
		// try to read from the cookie
		const cookie = document.cookie;
		const cookieParts = cookie.split(";");
		for (let i = 0; i < cookieParts.length; i++) {
			const cookiePart = cookieParts[i].trim();
			if (cookiePart.startsWith(`${this.tokenName}=`)) {
				this._backendToken = cookiePart.substring(this.tokenName.length + 1);
				logDebug(this.tokenName, "read from cookie:", this._backendToken);
				break;
			}
		}
		return this._backendToken;
	}

	public static get tokenName() {
		return `lev-Token`;
	}

	static updateBackendToken(data: any) {
		if (data[this.tokenName]) {
			this._backendToken = data[this.tokenName];
			logDebug(this.tokenName, "updated:", this._backendToken);
			// set local cookie
			document.cookie = `${this.tokenName}=${this._backendToken};max-age=3600;SameSite=Strict`;
			// logDebug('Lasso token updated ' + RestAPI._lassoToken);
		}
	}
	public static async getIdToken(): Promise<string | null> {
		try {
			if (getAuth().currentUser) {
				return await getAuth().currentUser!.getIdToken();
			}
		} catch (err) {
			logError("Error in getIdToken :", err);
		}
		return null;
	}
	public static async getBearerHeaders(): Promise<{ [s: string]: string }> {
		const authToken = (await this.getIdToken()) || "";
		let uid = "";
		try {
			// TODO :: move to one place with getIdToken
			uid = getAuth().currentUser!.uid;
		} catch (err) {}
		return {
			authorization: "Bearer " + authToken,
			uid,
			[this.tokenName]: NetworkIdentity._backendToken ?? "",
		};
	}
}
